import actionTypes from 'SRC/modules/redux/actionTypes'

export const setEditAd = ad => ({
  type: actionTypes.SET_EDIT_AD,
  payload: ad
})
